(function () {
  var productItemSelector = '.product-item[aria-hidden]';
  var focusableSelector = [
    'a[href]',
    'button',
    'input',
    'select',
    'textarea',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function setFocusableState(productItem) {
    if (!productItem || !productItem.matches(productItemSelector)) return;
    var isHidden = productItem.getAttribute('aria-hidden') === 'true';
    var focusables = productItem.querySelectorAll(focusableSelector);
    focusables.forEach(function (el) {
      if (isHidden) {
        if (!el.hasAttribute('data-polypet-original-tabindex')) {
          el.setAttribute('data-polypet-original-tabindex', el.getAttribute('tabindex') || '');
        }
        el.setAttribute('tabindex', '-1');
      } else {
        if (el.hasAttribute('data-polypet-original-tabindex')) {
          var originalTabindex = el.getAttribute('data-polypet-original-tabindex');
          if (originalTabindex === '') {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', originalTabindex);
          }
          el.removeAttribute('data-polypet-original-tabindex');
        }
      }
    });
  }

  function scanAll() {
    document.querySelectorAll(productItemSelector).forEach(setFocusableState);
  }

  function observeProductItem(productItem) {
    if (!productItem || productItem.hasAttribute('data-polypet-aria-observed')) return;
    productItem.setAttribute('data-polypet-aria-observed', 'true');
    itemObserver.observe(productItem, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
    setFocusableState(productItem);
  }

  var itemObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      setFocusableState(mutation.target);
    });
  });

  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches(productItemSelector)) {
          observeProductItem(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll(productItemSelector).forEach(observeProductItem);
        }
      });
    });
    scanAll();
  });

  function init() {
    document.querySelectorAll(productItemSelector).forEach(observeProductItem);
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    scanAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();